import React, { useState, useEffect } from "react";
import { I18nextProvider } from "react-i18next";
import i18n, { initI18n } from "./i18n";

export const TranslationProvider = ({ children }) => {
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    initI18n().then(() => {
      setInitialized(true);
    });
  }, []);

  if (!initialized) {
    return <div>Loading translations...</div>;
  }

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
};
